module.exports = __webpack_public_path__ + "2fcrYFNaTjcS6g4U3t-Y5UEw0lE80llgEseQY3FEmqw.f44512c065920ca2df45.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-google/2fcrYFNaTjcS6g4U3t-Y5UEw0lE80llgEseQY3FEmqw.woff2
// module id = ../../../../../src/assets/fonts/font-google/2fcrYFNaTjcS6g4U3t-Y5UEw0lE80llgEseQY3FEmqw.woff2
// module chunks = 40